exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PageHeader__header___2Gzr5 {\n  position: fixed;\n  top: 0;\n  left: 220px;\n  height: 50px;\n  padding: 10px;\n  z-index: 20;\n  line-height: 30px;\n  color: #434343;\n  font-size: 18px; }\n  .PageHeader__header___2Gzr5 .PageHeader__icon___2_tXO {\n    font-size: 14px;\n    margin: 0 5px;\n    color: #434343; }\n  .PageHeader__header___2Gzr5 a {\n    color: #999; }\n\n.PageHeader__header___2Gzr5 .glyphicon {\n  margin: 0 5px;\n  font-size: 14px;\n  line-height: 30px; }\n\n.PageHeader__noSidebar___2udZq {\n  left: 10px; }\n", ""]);

// exports
exports.locals = {
	"header": "PageHeader__header___2Gzr5",
	"icon": "PageHeader__icon___2_tXO",
	"noSidebar": "PageHeader__noSidebar___2udZq"
};